const DEFAULT_BOX_OPTIONS = {
	confirmButtonText: '确定',
	cancelButtonText: '取消',
	draggable: true
}

export const useMessage = (message) => {
	const resolveMessage = () => {
	    return typeof message === 'function' ? message() : message
	}

	const notify = (type = 'info', title = '信息提示', options = {}) => {
	    return ElNotification({
			type,
			title,
			message: resolveMessage(),
			...options
	    })
	}
	
	const show = (type = 'info', options = {}) => {
	    return ElMessage({
			showClose: true,
			message: resolveMessage(),
			type,
			...options
	    })
	}
	
	const success = (options = {}) => show('success', options)
	const error = (options = {}) => show('error', options)
	const warning = (options = {}) => show('warning', options)
	const info = (options = {}) => show('info', options)
	
	const alert = (title = '提示', options = {}) => {
	    return ElMessageBox.alert(resolveMessage(), title, {
			...DEFAULT_BOX_OPTIONS,
			...options
	    })
	}
	
	const confirm = async (title = '确认', options = {}) => {
		try {
			await ElMessageBox.confirm(resolveMessage(), title, {
				...DEFAULT_BOX_OPTIONS,
				...options
			})
			return true
		}
		catch(ex) {
			return false
		}
	}
	
	const prompt = (title = '输入', options = {}) => {
	    return ElMessageBox.prompt(resolveMessage(), title, {
			...DEFAULT_BOX_OPTIONS,
			...options
	    })
	}
	
	return {
	    notify,
	    show, success, error, warning, info,
	    alert,
	    confirm,
	    prompt
	}
}